import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { BaseToastComponent } from '../../../@commons/ui-components/toast-popup/base-toast-component';
import { SharedModule } from '../../../@commons/ui-components/shared.module';
import { TranslatePipe } from '@ngx-translate/core';
import { CheckIconComponent } from '../../../@icons/check-icon.component';
import { CloseIconComponent } from '../../../@icons/close-icon.component';

@Component({
  selector: 'vw-confirm-toast',
  imports: [
    SharedModule,
    TranslatePipe,
    CheckIconComponent,
    CloseIconComponent,
  ],
  templateUrl: './confirm-toast.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './confirm-toast.component.scss',
})
export class ConfirmToastComponent extends BaseToastComponent {
  @Input() confirmMessage: string;
  @Input() confirmYes: string;
  @Input() confirmNo: string;

  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
}
